<template>
  <a :href="url" :target="target">
    <span v-if="includeSpan">{{ title }}</span>
    <template v-else>{{ title }}</template>
  </a>
</template>

<script>
export default {
  props: {
    url: { default: '', required: true, type: String },
    target: { default: '_self', type: String },
    title: { default: '', type: String },
    includeSpan: {default: false, type: Boolean},
  },
}
</script>
